'use client'

import { createPortal } from 'react-dom'
import { useEffect, useState } from 'react'

export default function AdminHeaderBar({ post }: { post: any }) {
  const [pathName, setPathName] = useState<string | null>(null)
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const collapsed = localStorage.getItem('admin-header-collapsed')

      if (collapsed === 'true') {
        setIsCollapsed(true)
      }

      setPathName(window.location.pathname)
    }

    if (document.getElementById('admin-header')) {
      setPortalTarget(document.getElementById('admin-header'))
    }
  }, [])

  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed)

    if (typeof window !== 'undefined') {
      localStorage.setItem('admin-header-collapsed', isCollapsed ? 'false' : 'true')
    }
  }

  const {
    id: postId = null,
    revision_parent: parentId = null,
    term_id: termId = null,
    taxonomy: taxonomy = null,
  } = post || {}

  const cmsUrl = process.env.NEXT_PUBLIC_CMS_URL
  const adminUrl = `${cmsUrl}/wp-admin`

  const editId = parentId ? parentId : postId

  const renderAdminHeader = (
    <div className="pointer-events-none z-50 w-full font-[-apple-system,BlinkMacSystemFont,Roboto,Oxygen-Sans,Ubuntu,Cantarell,sans-serif] text-[13px] text-[#c3c4c7]">
      <div
        className={`admin-header pointer-events-auto relative z-[990] w-full overflow-visible bg-[#1d2327] px-xs ${isCollapsed ? 'hidden' : ''}`}>
        <div className="flex h-[32px]">
          <a
            href={adminUrl}
            target="_blank"
            className="inline-flex items-center gap-xxxs px-xxs before:font-[dashicons] before:text-[20px] before:content-['\f226'] hover:bg-[#2c3338] hover:text-[#72aee6]">
            Jersey Finance
          </a>

          {!termId && (postId || parentId) ? (
            <a
              href={`${adminUrl}/post.php?post=${editId}&action=edit`}
              target="_blank"
              className="inline-flex items-center gap-xxxs px-xxs before:font-[dashicons] before:text-[20px] before:content-['\f464'] hover:bg-[#2c3338] hover:text-[#72aee6]">
              Edit Page
            </a>
          ) : null}

          {termId && taxonomy ? (
            <a
              href={`${adminUrl}/wp-admin/term.php?taxonomy=${taxonomy}&tag_ID=${termId}`}
              target="_blank"
              className="inline-flex items-center gap-xxxs px-xxs before:font-[dashicons] before:text-[20px] before:content-['\f464'] hover:bg-[#2c3338] hover:text-[#72aee6]">
              Edit Category
            </a>
          ) : null}

          {pathName ? (
            <a
              href={`https://www.jerseyfinance.je${pathName}`}
              target="_blank"
              className="inline-flex items-center gap-xxxs px-xxs before:font-[dashicons] before:text-[20px] before:content-['\f115'] hover:bg-[#2c3338] hover:text-[#72aee6]">
              View on jerseyfinance.je
            </a>
          ) : null}
        </div>
      </div>
      <button
        onClick={() => handleCollapse()}
        className={`pointer-events-auto absolute right-0 top-0 z-[999] ml-auto inline-flex h-[32px] w-[45px] items-center justify-center gap-xxxs rounded-bl-md bg-[#1d2327] px-xxs text-[#c3c4c7]`}>
        {isCollapsed ? (
          <span className="dashicons dashicons-arrow-down-alt2"></span>
        ) : (
          <span className="dashicons dashicons-arrow-up-alt2"></span>
        )}
      </button>
    </div>
  )

  if (!portalTarget) return null

  return <>{createPortal(renderAdminHeader, portalTarget)}</>
}
